# Archives, libraries & books
https://archive.org
https://openlibrary.org
https://gutenberg.org
https://standardebooks.org
https://hathitrust.org
https://loc.gov
https://dp.la
https://worldcat.org
https://goodreads.com
https://librarything.com
https://bookfinder.com
https://isbnsearch.org
https://manybooks.net
https://feedbooks.com
https://smashwords.com
https://librivox.org
https://poetryfoundation.org
https://poets.org
https://tvtropes.org
https://fandom.com
https://wikiwand.com
https://publicdomainreview.org
https://longform.org
https://themarginalian.org
https://lithub.com
https://lareviewofbooks.org
https://bostonreview.net
https://3quarksdaily.com
